import { useRef, useState } from 'react'

const ClearableSearchInput = ({ defaultValue = '', onValueChange, ...props }) => {
  const inputRef = useRef(null)
  const [value, setValue] = useState(defaultValue ?? '')

  const handleChange = (event) => {
    setValue(event.target.value)
    onValueChange?.(event.target.value)
  }

  const handleClear = () => {
    setValue('')
    onValueChange?.('')
    inputRef.current?.focus()
  }

  return (
    <>
      <input
        {...props}
        ref={inputRef}
        type="search"
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button
          type="button"
          className="search-clear-button"
          aria-label="Clear search"
          onClick={handleClear}
        >
          ×
        </button>
      )}
    </>
  )
}

export default ClearableSearchInput
